// import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
// import "slick-carousel";

document.addEventListener('DOMContentLoaded', () => {

    const headerRow = document.querySelector('.header');

    if (!headerRow) return;

    const toggleHeaderClass = () => {
      if (window.scrollY > 0) {
        headerRow.classList.add('is-scrolled');
      } else {
        headerRow.classList.remove('is-scrolled');
      }
    };

    toggleHeaderClass(); // на случай перезагрузки не с top
    window.addEventListener('scroll', toggleHeaderClass, { passive: true });


// animation


if (window.innerWidth > 320) { 
    gsap.registerPlugin(ScrollTrigger);

    // Анимация слева
    gsap.utils.toArray('.anim-left').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%",
                toggleActions: "play none none reverse"
            },
            x: -40,
            opacity: 0,
            duration: 1.3,
            ease: "power3.out"
        });
    });

    // Справа
    gsap.utils.toArray('.anim-right').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%"
            },
            x: 80,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out"
        });
    });

    gsap.utils.toArray('.anim-right-footer').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 99%", 
                invalidateOnRefresh: true
            },
            x: 80,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out", 
            immediateRender: false
        });
    });

    // Снизу
    gsap.utils.toArray('.anim-bottom').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%"
            },
            y: 80,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out"
        });
    });

    // Снизу
    gsap.utils.toArray('.anim-top').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%"
            },
            y: -80,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out"
        });
    });

    // Плавное появление
    gsap.utils.toArray('.anim-fade').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%"
            },
            opacity: 0,
            duration: 1.3,
            
        });
    });

    // Scale-in (увеличение)
    gsap.utils.toArray('.anim-scale').forEach(block => {
        gsap.from(block, {
            scrollTrigger: {
                trigger: block,
                start: "top 90%"
            },
            scale: 0.85,
            opacity: 0,
            duration: 1.3,
            ease: "power3.out"
        });
    });

}

// animation


(function () {
  const GROUP_CONTAINER_SELECTOR = '.resource-list--grid'; // общий контейнер списка карточек
  const CARD_SELECTOR = '.p-card';                         // карточка
  const TARGET_SELECTORS = ['.p-card__title', '.p-card__helps-with'];

  const rafThrottle = (fn) => {
    let scheduled = false;
    return (...args) => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        fn(...args);
      });
    };
  };

  function resetHeights(container) {
    TARGET_SELECTORS.forEach(sel => {
      container.querySelectorAll(sel).forEach(el => {
        el.style.minHeight = '';
      });
    });
  }

  function equalizeInContainer(container) {
    if (!container) return;

    // сброс, чтобы корректно мерять после ресайза / смены шрифтов
    resetHeights(container);

    TARGET_SELECTORS.forEach(sel => {
      const elements = Array.from(container.querySelectorAll(sel))
        .filter(el => el.offsetParent !== null); // только видимые

      if (!elements.length) return;

      let max = 0;

      // меряем реальную высоту
      elements.forEach(el => {
        const h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });

      // задаём минимальную высоту
      elements.forEach(el => {
        el.style.minHeight = `${Math.ceil(max)}px`;
      });
    });
  }

  function run() {
    const groups = document.querySelectorAll(GROUP_CONTAINER_SELECTOR);
    if (!groups.length) return;

    groups.forEach(group => {
      // если в контейнере нет карточек — выходим
      if (!group.querySelector(CARD_SELECTOR)) return;
      equalizeInContainer(group);
    });
  }

  const runThrottled = rafThrottle(run);

  // 1) Первичная инициализация
  window.addEventListener('load', runThrottled);
  window.addEventListener('resize', runThrottled);

  // 2) Shopify: когда секции подгружаются/перерендериваются в редакторе и на фронте
  document.addEventListener('shopify:section:load', runThrottled);
  document.addEventListener('shopify:section:reorder', runThrottled);

  // 3) На случай динамики (фильтры, рекомендации, AJAX и т.д.)
  const mo = new MutationObserver(runThrottled);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 4) Запуск сразу (если DOM уже готов)
  runThrottled();
})();








});


